import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { scrollTo } from '@/utils/scroll-to';
let default_1 = class default_1 extends Vue {
  get currentPage() {
    return +this.page;
  }
  set currentPage(value) {
    this.$emit('update:page', value);
  }
  get pageSize() {
    return +this.limit;
  }
  set pageSize(value) {
    this.$emit('update:limit', value);
  }
  handleSizeChange(value) {
    this.$emit('pagination', {
      page: this.currentPage,
      limit: value
    });
    if (this.autoScroll) {
      scrollTo(0, 800);
    }
  }
  handleCurrentChange(value) {
    this.$emit('pagination', {
      page: value,
      limit: this.pageSize
    });
    if (this.autoScroll) {
      scrollTo(0, 800);
    }
  }
};
__decorate([Prop({
  required: true
})], default_1.prototype, "total", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "page", void 0);
__decorate([Prop({
  default: 2
})], default_1.prototype, "limit", void 0);
__decorate([Prop({
  default: () => [2, 10, 20, 30, 50]
})], default_1.prototype, "pageSizes", void 0);
__decorate([Prop({
  default: 'total, sizes, prev, pager, next, jumper'
})], default_1.prototype, "layout", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "background", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "autoScroll", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "hidden", void 0);
default_1 = __decorate([Component({
  name: 'Pagination'
})], default_1);
export default default_1;